import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { FavouriteButtonQuery } from './FavouriteButtonQuery.graphql';

export function preloadFavouriteButton(contentId, userId) {
	// skip preloading on SSR if user is not logged in
	if (!Boolean(userId)) {
		return Promise.resolve({});
	}

	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: FavouriteButtonQuery,
		variables: {
			contentId,
		},
	});
}
